export var getTraceIdFromExtensions = function getTraceIdFromExtensions(_ref) {
  var extensions = _ref.extensions;
  if (extensions !== undefined && extensions.gateway !== undefined && extensions.gateway !== null && typeof extensions.gateway.trace_id === 'string') {
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return extensions.gateway.trace_id;
  }
  return undefined;
};